module.exports = __webpack_public_path__ + "img/bank-054-hsbc.a542e534.svg";